import { ref } from "vue";

export function useAsyncOperation() {
    const isLoading = ref(false);

    async function manageAsyncOperation(
        callback,
        errorCallback,
        setLoading = null,
        noLoading = false,
    ) {
        if (!noLoading) {
            isLoading.value = true;
            setLoading?.(true);
        }

        try {
            return await callback?.();
        } catch (error) {
            console.log("error in manageAsyncOperation", error);
            return errorCallback?.(error);
        } finally {
            if (!noLoading) {
                isLoading.value = false;
                setLoading?.(false);
            }
        }
    }

    return { isLoading, manageAsyncOperation };
}
